import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DispatchDeviceListComponent } from './dispatch-device-list.component';

const routes: Routes = [
  {
    path: 'dispatch-device-list',
    data: { name: 'Dispatch Device', isTab: false },
    component: DispatchDeviceListComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DispatchDeviceListRoutingModule {}
